import * as api from "@/api";
import { globals } from "@/globals";
import * as signals from "@/signals";
import { uninstallServiceWorker } from "@/utils";

class Cleaner {
	public async clearAll(): Promise<void> {
		await this.uninstallServiceWorker();
		if (signals.login.value.username) {
			await this.deleteSettings();
			await this.logOut();
		}
		await this.clearCache();
		await this.clearLocalStorage();
		await this.clearSessionStorage();
		this.deleteIndexedDB();
		await this.clearSiteData();
		window.location.reload();
	}

	private async clearCache(): Promise<void> {
		try {
			if (!window.caches) {
				return;
			}
			const keys = await caches.keys();
			for (const key of keys) {
				await caches.delete(key);
			}
			console.info("Cache cleared.");
		} catch (error) {
			await api.handleApiError(error);
		}
	}

	private async clearLocalStorage(): Promise<void> {
		try {
			localStorage.clear();
			console.info("Local storage cleared.");
		} catch (error) {
			await api.handleApiError(error);
		}
	}

	private async clearSessionStorage(): Promise<void> {
		try {
			sessionStorage.clear();
			console.info("Session storage cleared.");
		} catch (error) {
			await api.handleApiError(error);
		}
	}

	private async clearSiteData(): Promise<void> {
		signals.isLoadingShown.value = true;
		try {
			await api.clearSiteData();
			signals.isLoadingShown.value = false;
			console.info("Site data cleared.");
		} catch (error) {
			signals.isLoadingShown.value = false;
			await api.handleApiError(error);
		}
	}

	private async deleteSettings(): Promise<void> {
		signals.isLoadingShown.value = true;
		try {
			await api.deleteSettings();
			signals.isLoadingShown.value = false;
			console.info("Settings deleted.");
		} catch (error) {
			signals.isLoadingShown.value = false;
			await api.handleApiError(error);
		}
	}

	private deleteIndexedDB(): void {
		indexedDB.deleteDatabase(globals.APP_NAME);
	}

	private async logOut(): Promise<void> {
		signals.isLoadingShown.value = true;
		try {
			await api.logOut();
		} catch (error) {
			void api.handleApiError(error);
		} finally {
			signals.isLoadingShown.value = false;
		}
	}

	private async uninstallServiceWorker(): Promise<void> {
		try {
			await uninstallServiceWorker();
		} catch (error) {
			await api.handleApiError(error);
		}
	}
}

export default Cleaner;
